<!-- CAROUSEL - MOBILE -->
<div *ngIf="type === 'catalogs_mobile'" class="w-full">

    <div class="px-5 mt-5 sm:px-5 md:px-10 lg:px-10 xl:px-40">
        <app-title-section [title]="'Catálogo de nuestros productos'" [type]="'title'">
        </app-title-section>
    </div>

    <div class="carouselContainerSlider bgsigmaprodcatcar">
        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="carouselCatalogConfig">
            <div ngxSlickItem *ngFor="let itemCatalog of dataCat?.catalog" class="px-14 sm:px-36">
                <div
                    class="flex flex-col items-center justify-start w-full h-full text-white border-gray-300 border-none shadow-lg cursor-pointer rounded-xl divProdCatcar">
                    <div class="flex flex-row items-center justify-center w-full h-24 p-3">
                        <p class="text-2xl text-center sm:text-3xl">
                            {{itemCatalog.title}}</p>
                    </div>
                    <div
                        class="flex flex-row items-center justify-center w-full h-auto p-3 bg-white border-2 border-gray-200 rounded-b-lg imgProd">
                        <!-- <div
                            class="flex flex-row items-center justify-center w-full pb-24 rounded-t-lg rounded-l-none h-60 "> -->
                        <picture class="px-0 mt-5 transform scale-110">
                            <source class="w-auto" type="image/webp" [attr.defaultImage]="itemCatalog.icon +'.webp'"
                                [attr.lazyLoad]="itemCatalog.icon +'.webp'" />
                            <img class="w-auto bg-bottom bg-no-repeat bg-cover h-60"
                                [defaultImage]="itemCatalog.icon +'.jpg'" [lazyLoad]="itemCatalog.icon +'.jpg'" />
                        </picture>
                        <!-- </div> -->
                    </div>
                </div>
            </div>
        </ngx-slick-carousel>
        <div class="nav-btn">
            <button class="slideb-prev fas fa-chevron-left" (click)="slickModal.slickPrev()"></button>
            <button class="slideb-next fas fa-chevron-right" (click)="slickModal.slickNext()"></button>
        </div>
    </div>

</div>